import { createAction } from 'redux-act';

export const DOMAINDATA_SET_DATA = createAction('DOMAINDATA_SET_DATA');

export const setDomainData = data => dispatch => {
  return dispatch(DOMAINDATA_SET_DATA({ data }));
};
